import { useState, useEffect, useRef, useCallback } from 'react';
import { fetchAvailableModels, AvailableModel } from 'api/prediction-engine';

export const useAvailableModels = () => {
  const [models, setModels] = useState<AvailableModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const fetchingRef = useRef(false);
  const hasFetchedRef = useRef(false);

  const fetchModels = useCallback(async () => {
    if (fetchingRef.current) return;
    
    fetchingRef.current = true;
    setIsLoading(true);
    setError(null);
    
    try {
      const result = await fetchAvailableModels();
      
      setModels(result);
      hasFetchedRef.current = true;
    } catch (error) {
      setError('Failed to fetch available models');
      setModels([]);
    } finally {
      setIsLoading(false);
      fetchingRef.current = false;
    }
  }, []);

  const refetch = useCallback(async () => {
    if (fetchingRef.current) return;
    await fetchModels();
  }, [fetchModels]);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchModels();
    }
  }, [fetchModels]);

  return {
    models,
    isLoading,
    error,
    refetch,
  };
};